import { Pagination } from 'react-bootstrap'
import './TableStyle.css'

function PageSelector({ totalPages, selectedPage, handlePageSelect }) {
  const nextPage = () => {
    if (totalPages !== selectedPage) {
      handlePageSelect(selectedPage + 1)
    }
  }
  const prevPage = () => {
    if (selectedPage !== 1) {
      handlePageSelect(selectedPage - 1)
    }
  }

  return (
    <div className='PageSelector flex w-fit m-0  d-flex items-center space-x-2 justify-content-center' style={{color: '#4c9a3a'}}>
      <Pagination>
        <Pagination.Prev
          onClick={prevPage}
          style={{
            backgroundColor: selectedPage === 1 ? '#d3d3d3' : '#59c50f42',
            cursor: selectedPage === 1 ? 'not-allowed' : 'pointer',
            borderRadius: 5,
          }}
        />
        {Array.from({ length: totalPages }).map((e, index) => (
          <Pagination.Item
            key={index}
            active={selectedPage === index + 1}
            style={{
              backgroundColor:
                selectedPage === index + 1 ? '#d3d3d3' : '#59c50f42',
              cursor: selectedPage === index + 1 ? 'not-allowed' : 'pointer',
              borderRadius: 5,
            }}
            onClick={() => handlePageSelect(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={nextPage}
          style={{
            backgroundColor:
              selectedPage === totalPages ? '#d3d3d3' : '#59c50f42',
            cursor: selectedPage === totalPages ? 'not-allowed' : 'pointer',
            borderRadius: 5,
          }}
        />
      </Pagination>
    </div>
  )
}
export default PageSelector
